export const ERROR_MESSAGES = {
  400: 'Invalid request. Please check your input.',
  401: 'You are not authorized to perform this action.',
  403: `You don't have permission to access this resource.`,
  404: 'The requested resource was not found.',
  500: 'An unexpected error occurred. Please try again later.',
  0: 'An unexpected error occurred. Please try again later.',
  default: 'An unknown error occurred. Please try again.',
};
